import {
    createHeadline,
    Headline,
} from '@vfde-brix/ws10/headline';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { selectIsEligibleForRestlaufzeit } from 'Container/App/slice';
import { startAppListening } from 'Container/App/listener';
import { RESTLAUFZEIT_HEADLINE_CONTAINER } from 'Container/App/constants';

/**
 * Mount headline element
 */
export default function mountRestlaufzeitHeadline (): Headline | null {
    const headline = createComponentById(createHeadline, RESTLAUFZEIT_HEADLINE_CONTAINER, NO_PATTERN_BUSINESS_LOGIC);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsEligibleForRestlaufzeit(currentState) !== selectIsEligibleForRestlaufzeit(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const isEligibleForRestlaufzeit = selectIsEligibleForRestlaufzeit(api.getState());

            headline?.toggleContainer(!isEligibleForRestlaufzeit);
        },
    });

    return headline;
}
